exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.show-button[data-v-17eb2352]{\n\tborder:0;\n\theight: auto;\n}\n", ""]);

// exports
